import React from 'react';
import { Wrench, CircleDot, Truck } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Wrench: Wrench,
  CircleDot: CircleDot,
  Truck: Truck
};

export const Services = () => {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-600 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-pink-600 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Våra <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">Tjänster</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Vi erbjuder ett komplett utbud av biltjänster för alla märken och modeller
          </p>
        </div>

        {/* Additional Info */}
        <div className="text-center mb-8">
          <p className="text-gray-300 text-xl font-semibold">
            Vi kan hantera allt inom bilverkstad – oavsett märke eller modell
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="group bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-700/50 hover:border-purple-500/50 transition-all duration-500 hover:shadow-2xl hover:shadow-purple-500/20 hover:-translate-y-2"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="mb-6 relative">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-pink-600 rounded-xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-lg shadow-purple-500/50">
                    <Icon size={32} className="text-white" />
                  </div>
                  <div className="absolute inset-0 w-16 h-16 bg-gradient-to-br from-purple-600 to-pink-600 rounded-xl blur-xl opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-white mb-4 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-purple-400 group-hover:to-pink-400 transition-all duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-400 leading-relaxed text-base">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
